import { HighchartsExportWrapper } from 'components/shared/Highcharts/HighchartsExportWrapper';
import { HighchartsReact } from 'highcharts-react-official';

import './style.scss';
import Highcharts, { Options } from 'highcharts/highstock';
import { useSgBsTheme } from 'hooks/useSgBsTheme';
import { toHighchartsTheme } from 'utils/highcharts';

export type BackTestChartsWrapperProps = {
  highchartsOptions: Options;
  hasCopyToClipBoard?: boolean;
};

export function BackTestChartsWrapper({ highchartsOptions, hasCopyToClipBoard = false }: BackTestChartsWrapperProps) {
  const theme = useSgBsTheme();
  return (
    <HighchartsExportWrapper
      Chart={({ highchartsOptions, chartComponentRef }) => (
        <div className={'backtest-highcharts-container'}>
          <HighchartsReact
            highcharts={Highcharts}
            options={highchartsOptions}
            ref={chartComponentRef}
            theme="dark"
            containerProps={{ className: toHighchartsTheme(theme) }}
          />
        </div>
      )}
      highchartsOptions={highchartsOptions}
      hasCopyToClipBoard={hasCopyToClipBoard}
    />
  );
}
